import { render, staticRenderFns } from "./ActionPersonAssist.vue?vue&type=template&id=66377505"
import script from "./ActionPersonAssist.vue?vue&type=script&lang=js"
export * from "./ActionPersonAssist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports